// tsc does not recognize jsx extension therefor renaming to tsx
import AuthProvider from '../providers/AuthProvider';

/**
 * Handles silent signin
 * @returns {AuthConsumer}
 * @constructor
 */
export const signInSilentCallback = () => AuthProvider.createConsumer('signInSilentCallback', '');
